<template>
     <footer class="footer bg-secondary">
      <div class="container-fluid">
        <span class="text-muted">Copyright &copy; {{year}} - Conectra Sistemas. All rights reserved</span>
      </div>
    </footer>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
}
</style>


